import { TextField, TextFieldProps } from '@mui/material';
import { VIEW_MODE } from '../../consts/enums';

type CustomTextFieldProps = TextFieldProps & {
  viewMode?: ViewMode,
};

const CustomTextField = ({
  viewMode,
  ...muiProps
}: CustomTextFieldProps): JSX.Element | null => {
  const isReadOnly = viewMode === VIEW_MODE.READ_ONLY;

  const combinedProps = {
    ...muiProps,
    ...(isReadOnly) && {
      InputProps: { readOnly: true, disableUnderline: true },
      placeholder: '',
      value: muiProps.value || ' ',
      error: undefined,
      // Added the prop to override the rows prop inside muiProps
      rows: undefined,
    },
  };

  if (viewMode === VIEW_MODE.HIDDEN) {
    return null;
  }

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <TextField { ...combinedProps }
      variant={ isReadOnly ? 'standard' : muiProps.variant }
    />
  );
};

CustomTextField.defaultProps = {
  viewMode: VIEW_MODE.READ_ONLY,
};

export default CustomTextField;
